import {
  DialogContent,
  Paper,
  Typography,
  Grid,
  Box,
  TextField,
  IconButton,
  Collapse,
  Divider,
  FormHelperText,
} from "@mui/material";
import React, { useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Radio } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormControl from "@mui/material/FormControl";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import { useFormik } from "formik";
import { useParams } from "react-router";
import moment, { duration } from "moment";
import * as Yup from "yup";
import api from "_api";

const invoiceFields = [
  [
    {
      label: "วันที่ออกใบแจ้งหนี้",
      name: "invoiceDate",
      type: "date",
      required: true,
    },
  ],
  [{ label: "รายการ", name: "item", type: "text", required: true }],
  [
    {
      label: "เริ่มการใช้งานวันที่",
      name: "startDate",
      type: "date",
      required: true,
    },
  ],
  [
    { label: "ระยะเวลา", name: "duration", type: "select", required: true },
    {
      label: "ค่าบริการ (ต่อปี) ",
      name: "annualCost",
      type: "number",
      required: true,
    },
  ],
  [{ label: "ส่วนลด", name: "discount", type: "radio", required: false }],
  [
    { label: "หมายเหตุ", name: "note", type: "text", required: false },
    {
      label: "จำนวนเงินที่ลด",
      name: "discountAmount",
      type: "number",
      required: false,
    },
  ],
];

const durationOptions = [
  { id: 1, label: "1 ปี", value: "1" },
  { id: 2, label: "2 ปี", value: "2" },
  { id: 3, label: "3 ปี ", value: "3" },
  { id: 4, label: "4 ปี ", value: "4" },
  { id: 5, label: "5 ปี ", value: "5" },
];

const BillDebtForm = () => {
  // const [selectedDiscount, setSelectedDiscount] = useState("");
  // const [selectedDuration, setSelectedDuration] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  // const [duration_pawnShop, setDuration_pawnShop] = useState("");
  // const [duration_UsedCars, setDuration_UsedCars] = useState("");

  let params = useParams();

  const handleClick = () => {
    // setIsChecked(!isChecked);
    // setSelectedDiscount((prev) =>
    //   prev === selectedDiscount ? "" : selectedDiscount
    // );
    setIsChecked((prevChecked) => {
      const newChecked = !prevChecked;
      //setSelectedDiscount(newChecked ? "1" : "" );
      formik.setFieldValue(
        "invoiceFieldsValues.discount",
        newChecked ? "true" : "false"
      );
      return newChecked;
    });
  };

  //ฟังก์ชันแสดง Explanded
  const handleExpandClick = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
    //setOpen((prevOpen) => !prevOpen);
  };

  const renderPawnShop = () => {
    return (
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center" // Add this to center items vertically
          //onClick={() => toggleExpand(box.id)}
        >
          <Typography sx={{ mb: 1, ml: 2 }} variant="h6">
            โรงรับจำนำ
          </Typography>

          <div>
            <IconButton
              size="small"
              color="#ccc"
              onClick={() => handleExpandClick(1)}
              style={{
                transform: expandedRow === 1 ? "rotate(180deg)" : "none",
                transition: "transform 0.2s ease-in-out",
                marginLeft: "10px",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </div>
        </Box>

        <Collapse in={expandedRow === 1}>
          <Grid container>
            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Grid item xs={12}>
                <Divider />
                <Box display="flex" alignItems="center">
                  <Grid
                    display="flex"
                    alignItems="center"
                    sx={{ marginTop: "20px" }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        width: "170px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      เริ่มการใช้งานวันที่
                    </Typography>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          name="pawnShop.startDate_pawnShop"
                          value={
                            formik.values.pawnShop.startDate_pawnShop
                              ? moment(
                                  formik.values.pawnShop.startDate_pawnShop,
                                  "YYYY-MM-DD"
                                )
                              : null
                          }
                          onChange={(date) =>
                            formik.setFieldValue(
                              "pawnShop.startDate_pawnShop",
                              date ? date.format("YYYY-MM-DD") : ""
                            )
                          }
                          sx={{
                            width: "245px",
                            whiteSpace: "nowrap",
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>
                </Box>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Box display="flex" alignItems="center">
                <Grid display="flex" alignItems="center">
                  <Typography
                    variant="subtitle1"
                    sx={{
                      width: "170px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ระยะเวลา
                  </Typography>

                  <Select
                    //value={duration_pawnShop}
                    // label="Age"
                    //onChange={(e) => setDuration_pawnShop(e.target.value)}
                    name="pawnShop.duration_pawnShop"
                    value={formik.values.pawnShop.duration_pawnShop}
                    onChange={formik.handleChange}
                    sx={{
                      minWidth: 245,
                      marginRight: "30px",
                    }}
                  >
                    {durationOptions.map(({ id, label, value }) => (
                      <MenuItem key={id} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Box display="flex" alignItems="center">
                <Grid display="flex" alignItems="center">
                  <Typography
                    variant="subtitle1"
                    sx={{
                      width: "170px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ค่าบริการ
                  </Typography>

                  <TextField
                    name="pawnShop.annualCost_pawnShop"
                    size="small"
                    type="number"
                    value={formik.values.pawnShop.annualCost_pawnShop}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.pawnShop?.annualCost_pawnShop &&
                      Boolean(formik.errors.pawnShop?.annualCost_pawnShop)
                    }
                    helperText={
                      formik.touched.pawnShop?.annualCost_pawnShop &&
                      formik.errors.pawnShop?.annualCost_pawnShop
                    }
                    InputProps={{
                      sx: {
                        height: "40px",
                        padding: "0px",
                        marginRight: "30px",
                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                          {
                            display: "none",
                          },
                        "& input[type=number]": {
                          MozAppearance: "textfield",
                        },
                      },
                    }}
                  />
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Collapse>
      </>
    );
  };

  const renderUsedCar = () => {
    return (
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center" // Add this to center items vertically
          //onClick={() => toggleExpand(box.id)}
        >
          <Typography sx={{ mb: 1, ml: 2 }} variant="h6">
            รถมือสอง
          </Typography>
          <div>
            <IconButton
              size="small"
              color="#ccc"
              onClick={() => handleExpandClick(2)}
              style={{
                transform: expandedRow === 2 ? "rotate(180deg)" : "none",
                transition: "transform 0.2s ease-in-out",
                marginLeft: "10px",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </div>
        </Box>

        <Collapse in={expandedRow === 2}>
          <Grid container>
            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Grid item xs={12}>
                <Divider />
                <Box display="flex" alignItems="center">
                  <Grid
                    display="flex"
                    alignItems="center"
                    sx={{ marginTop: "20px" }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        width: "170px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      เริ่มการใช้งานวันที่
                    </Typography>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          name="usedCar.startDate_usedCar"
                          value={
                            formik.values.usedCar.startDate_usedCar
                              ? moment(
                                  formik.values.usedCar.startDate_usedCar,
                                  "YYYY-MM-DD"
                                )
                              : null
                          }
                          onChange={(date) =>
                            formik.setFieldValue(
                              "usedCar.startDate_usedCar",
                              date ? date.format("YYYY-MM-DD") : ""
                            )
                          }
                          sx={{
                            width: "245px",
                            whiteSpace: "nowrap",
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>
                </Box>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Box display="flex" alignItems="center">
                <Grid display="flex" alignItems="center">
                  <Typography
                    variant="subtitle1"
                    sx={{
                      width: "170px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ระยะเวลา
                  </Typography>

                  <Select
                    //value={duration_UsedCars}
                    // label="Age"
                    name="usedCar.duration_usedCar"
                    value={formik.values.usedCar.duration_usedCar}
                    onChange={formik.handleChange}
                    sx={{
                      minWidth: 245,
                      marginRight: "30px",
                    }}
                  >
                    {durationOptions.map(({ id, label, value }) => (
                      <MenuItem key={id} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Box display="flex" alignItems="center">
                <Grid display="flex" alignItems="center">
                  <Typography
                    variant="subtitle1"
                    sx={{
                      width: "170px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ค่าบริการ
                  </Typography>

                  <TextField
                    name="usedCar.annualCost_usedCar"
                    size="small"
                    type="number"
                    value={formik.values.usedCar.annualCost_usedCar}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.usedCar?.annualCost_usedCar &&
                      Boolean(formik.errors.usedCar?.annualCost_usedCar)
                    }
                    helperText={
                      formik.touched.usedCar?.annualCost_usedCar &&
                      formik.errors.usedCar?.annualCost_usedCar
                    }
                    InputProps={{
                      sx: {
                        height: "40px",
                        padding: "0px",
                        marginRight: "30px",
                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                          {
                            display: "none",
                          },
                        "& input[type=number]": {
                          MozAppearance: "textfield",
                        },
                      },
                    }}
                  />
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Collapse>
      </>
    );
  };

  const renderLand = () => {
    return (
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center" // Add this to center items vertically
          //onClick={() => toggleExpand(box.id)}
        >
          <Typography sx={{ mb: 1, ml: 2 }} variant="h6">
            ที่ดิน
          </Typography>
          <div>
            <IconButton
              size="small"
              color="#ccc"
              onClick={() => handleExpandClick(3)}
              style={{
                transform: expandedRow === 3 ? "rotate(180deg)" : "none",
                transition: "transform 0.2s ease-in-out",
                marginLeft: "10px",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </div>
        </Box>

        <Collapse in={expandedRow === 3}>
          <Grid container>
            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Grid item xs={12}>
                <Divider />
                <Box display="flex" alignItems="center">
                  <Grid
                    display="flex"
                    alignItems="center"
                    sx={{ marginTop: "20px" }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        width: "170px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      เริ่มการใช้งานวันที่
                    </Typography>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          name="land.startDate_land"
                          value={
                            formik.values.land.startDate_land
                              ? moment(
                                  formik.values.land.startDate_land,
                                  "YYYY-MM-DD"
                                )
                              : null
                          }
                          onChange={(date) =>
                            formik.setFieldValue(
                              "land.startDate_land",
                              date ? date.format("YYYY-MM-DD") : ""
                            )
                          }
                          sx={{
                            width: "245px",
                            whiteSpace: "nowrap",
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>
                </Box>
              </Grid>
            </Grid>

            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Box display="flex" alignItems="center">
                <Grid display="flex" alignItems="center">
                  <Typography
                    variant="subtitle1"
                    sx={{
                      width: "170px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ระยะเวลา
                  </Typography>

                  <Select
                    name="land.duration_land"
                    value={formik.values.land.duration_land}
                    onChange={formik.handleChange}
                    sx={{
                      minWidth: 245,
                      marginRight: "30px",
                    }}
                  >
                    {durationOptions.map(({ id, label, value }) => (
                      <MenuItem key={id} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
              <Box display="flex" alignItems="center">
                <Grid display="flex" alignItems="center">
                  <Typography
                    variant="subtitle1"
                    sx={{
                      width: "170px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    ค่าบริการ
                  </Typography>

                  <TextField
                    name="land.annualCost_land"
                    size="small"
                    type="number"
                    value={formik.values.land.annualCost_land}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.land?.annualCost_land &&
                      Boolean(formik.errors.land?.annualCost_land)
                    }
                    helperText={
                      formik.touched.land?.annualCost_land &&
                      formik.errors.land?.annualCost_land
                    }
                    InputProps={{
                      sx: {
                        height: "40px",
                        padding: "0px",
                        marginRight: "30px",
                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                          {
                            display: "none",
                          },
                        "& input[type=number]": {
                          MozAppearance: "textfield",
                        },
                      },
                    }}
                  />
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Collapse>
      </>
    );
  };

  const validationSchema = Yup.object().shape({
    invoiceFieldsValues: Yup.object().shape({
      invoiceDate: Yup.string().required("กรุณากรอกวันที่ออกใบแจ้งหนี้"),
      item: Yup.string().required("กรุณากรอกชื่อรายการ"),
      startDate: Yup.string().required("กรุณากรอกวันที่เริ่มใช้งาน"),
      duration: Yup.string().required("กรุณากรอกระยะเวลา"),
      annualCost: Yup.number()
        .required("กรุณากรอกค่าบริการต่อปี")
        .min(0, "กรุณากรอกตัวเลขค่าบริการให้มากกว่าหรือเท่ากับ 0"),
      discountAmount: Yup.number().min(
        0,
        "กรุณากรอกตัวเลขค่าบริการให้มากกว่าหรือเท่ากับ 0"
      ),
    }),
    pawnShop: Yup.object().shape({
      annualCost_pawnShop: Yup.number().min(
        0,
        "กรุณากรอกตัวเลขค่าบริการให้มากกว่าหรือเท่ากับ 0"
      ),
    }),
    usedCar: Yup.object().shape({
      annualCost_usedCar: Yup.number().min(
        0,
        "กรุณากรอกตัวเลขค่าบริการให้มากกว่าหรือเท่ากับ 0"
      ),
    }),
    land: Yup.object().shape({
      annualCost_land: Yup.number().min(
        0,
        "กรุณากรอกตัวเลขค่าบริการให้มากกว่าหรือเท่ากับ 0"
      ),
    }),
  });

  const formik = useFormik({
    initialValues: {
      invoiceFieldsValues: {
        invoiceDate: "", //วันที่ออกใบแจ้งหนี้
        item: "", //รายการ
        startDate: "", // เริ่มการใช้งานวันที่
        duration: "", //ระยะเวลา
        discount: false, // ส่วดลด
        annualCost: "", // ค่าบริการ (ต่อปี)
        note: "", //หมายเหตุ
        discountAmount: 0, //จำนวนเงินที่ลด
        company_id: "",
      },
      pawnShop: {
        startDate_pawnShop: "",
        duration_pawnShop: "",
        annualCost_pawnShop: "",
      },
      usedCar: {
        startDate_usedCar: "",
        duration_usedCar: "",
        annualCost_usedCar: "",
      },
      land: {
        startDate_land: "",
        duration_land: "",
        annualCost_land: "",
      },
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { invoiceFieldsValues, pawnShop, usedCar, land } = values;

      const hasPawnShopData =
        (pawnShop.startDate_pawnShop &&
          pawnShop.duration_pawnShop &&
          pawnShop.annualCost_pawnShop) ||
        (pawnShop.startDate_pawnShop == "" &&
          pawnShop.duration_pawnShop == "" &&
          pawnShop.annualCost_pawnShop == "");

      const hasUsedCarData =
        (usedCar.startDate_usedCar &&
          usedCar.duration_usedCar &&
          usedCar.annualCost_usedCar) ||
        (usedCar.startDate_usedCar == "" &&
          usedCar.duration_usedCar == "" &&
          usedCar.annualCost_usedCar == "");

      const hasLandData =
        (land.startDate_land && land.duration_land && land.annualCost_land) ||
        (land.startDate_land == "" &&
          land.duration_land == "" &&
          land.annualCost_land == "");

      if (!hasPawnShopData || !hasUsedCarData || !hasLandData) {
        // ไม่มีการกรอกข้อมูลใน pawnShop และ usedCar
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
        return;
      }
      const data = {
        invoice_date: invoiceFieldsValues.invoiceDate, //วันที่ออกใบแจ้งหนี้
        title: invoiceFieldsValues.item, //รายการ
        start_date: invoiceFieldsValues.startDate, // เริ่มการใช้งานวันที่
        duration: invoiceFieldsValues.duration, //ระยะเวลา
        is_discount: invoiceFieldsValues.discount, //ส่วนลด 1 หรือ 0
        service_fee: invoiceFieldsValues.annualCost, //ค่าบริการ ต่อ ปี
        comment: invoiceFieldsValues.note, //หมายเหตุ
        discount_cost: invoiceFieldsValues.discountAmount, //จำนวนที่ลด
        company_id: params.company_id,

        ...(hasPawnShopData &&
          pawnShop.startDate_pawnShop != "" && {
            pawn: {
              start_date: pawnShop.startDate_pawnShop,
              duration: pawnShop.duration_pawnShop,
              service_fee: pawnShop.annualCost_pawnShop,
            },
          }),
        ...(hasUsedCarData &&
          usedCar.startDate_usedCar != "" && {
            pawn: {
              start_date: usedCar.startDate_usedCar,
              duration: usedCar.duration_usedCar,
              service_fee: usedCar.annualCost_usedCar,
            },
          }),
        ...(hasLandData &&
          land.startDate_land != "" && {
            land: {
              start_date: land.startDate_land,
              duration: land.duration_land,
              service_fee: land.annualCost_land,
            },
          }),
      };

      console.log("Data to send:", data);
      const { isStatus } = await api.super_admin.createBill(data);
      if (isStatus) {
        window.location.href = "/admin";
      }
    },
    // alert(JSON.stringify(values.invoiceFieldsValues, null, 2)),
  });

  return (
    <>
      <Typography component="div" style={{ fontSize: "32px" }}>
        สร้างใบแจ้งหนี้สำหรับโปรแกรม
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <Grid item xs={12} sx={{ mx: 2 }}>
            <Paper sx={{ p: 2, borderRadius: "12px" }}>
              <Typography sx={{ mb: 1, ml: 2 }} variant="h6">
                กรุณากรอกข้อมูลเพื่อทำการสร้างใบแจ้งหนี้
              </Typography>
              <Divider sx={{ margin: 2 }} />
              <Grid container>
                {invoiceFields.map((group, groupIndex) => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    sx={{ margin: 2 }}
                    key={`group-${groupIndex}`}
                  >
                    <Box display="flex" alignItems="center">
                      {group.map((field) => (
                        <Box
                          display="flex"
                          key={field.name}
                          alignItems="center"
                        >
                          <Typography
                            variant="subtitle1"
                            sx={{
                              width: "170px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {field.label}
                          </Typography>

                          {field.type === "text" ? (
                            <TextField
                              id={field.name}
                              name={`invoiceFieldsValues.${field.name}`}
                              size="small"
                              InputProps={{
                                sx: {
                                  height: "40px",
                                  padding: "0px",
                                  marginRight: "30px",
                                },
                              }}
                              value={
                                formik.values.invoiceFieldsValues[field.name]
                              }
                              onChange={formik.handleChange}
                              error={
                                formik.touched.invoiceFieldsValues?.[
                                  field.name
                                ] &&
                                Boolean(
                                  formik.errors.invoiceFieldsValues?.[
                                    field.name
                                  ]
                                )
                              }
                              helperText={
                                formik.touched.invoiceFieldsValues?.[
                                  field.name
                                ] &&
                                formik.errors.invoiceFieldsValues?.[field.name]
                              }
                              onBlur={formik.handleBlur}
                            />
                          ) : field.type === "date" ? (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DemoContainer components={["DatePicker"]}>
                                <DatePicker
                                  name={`invoiceFieldsValues.${field.name}`}
                                  //required={field.required}
                                  sx={{
                                    width: "245px",
                                    minHeight: "40px",
                                    whiteSpace: "nowrap",
                                  }}
                                  value={
                                    formik.values.invoiceFieldsValues[
                                      field.name
                                    ]
                                      ? moment(
                                          formik.values.invoiceFieldsValues[
                                            field.name
                                          ],
                                          "YYYY-MM-DD"
                                        )
                                      : null
                                  }
                                  onChange={(date) => {
                                    formik.setFieldValue(
                                      `invoiceFieldsValues.${field.name}`,
                                      date ? date.format("YYYY-MM-DD") : null
                                    );
                                  }}
                                  onBlur={() =>
                                    formik.setFieldTouched(
                                      `invoiceFieldsValues.${field.name}`,
                                      true
                                    )
                                  }
                                  slotProps={{
                                    textField: {
                                      error:
                                        formik.touched.invoiceFieldsValues?.[
                                          field.name
                                        ] &&
                                        Boolean(
                                          formik.errors.invoiceFieldsValues?.[
                                            field.name
                                          ]
                                        ),
                                      helperText:
                                        formik.touched.invoiceFieldsValues?.[
                                          field.name
                                        ] &&
                                        formik.errors.invoiceFieldsValues?.[
                                          field.name
                                        ],
                                    },
                                  }}
                                />
                              </DemoContainer>
                            </LocalizationProvider>
                          ) : field.type === "radio" ? (
                            <RadioGroup
                              aria-labelledby="demo-controlled-radio-buttons-group"
                              name={`invoiceFieldsValues.${field.name}`}
                              value={
                                formik.values.invoiceFieldsValues[field.name]
                              }
                              onChange={formik.handleChange}
                            >
                              <FormControlLabel
                                value="true"
                                control={
                                  <Radio
                                    checked={isChecked}
                                    onClick={handleClick}
                                  />
                                } //1 ให้ส่วนลด
                                label="ให้ส่วนลด"
                              />
                            </RadioGroup>
                          ) : field.type === "number" ? (
                            <TextField
                              id={field.name}
                              name={`invoiceFieldsValues.${field.name}`}
                              size="small"
                              type="number"
                              InputProps={{
                                inputProps: {
                                  min: 0,
                                  step: 1,
                                },
                                sx: {
                                  height: "40px",
                                  padding: "0px",
                                  marginRight: "30px",
                                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                    {
                                      display: "none",
                                    },
                                  "& input[type=number]": {
                                    MozAppearance: "textfield",
                                  },
                                },
                              }}
                              value={
                                formik.values.invoiceFieldsValues[field.name]
                              }
                              onChange={formik.handleChange}
                              error={
                                formik.touched.invoiceFieldsValues?.[
                                  field.name
                                ] &&
                                Boolean(
                                  formik.errors.invoiceFieldsValues?.[
                                    field.name
                                  ]
                                )
                              }
                              helperText={
                                formik.touched.invoiceFieldsValues?.[
                                  field.name
                                ] &&
                                formik.errors.invoiceFieldsValues?.[field.name]
                              }
                              onBlur={formik.handleBlur}
                            />
                          ) : (
                            <FormControl
                              error={
                                formik.touched.invoiceFieldsValues?.[
                                  field.name
                                ] &&
                                Boolean(
                                  formik.errors.invoiceFieldsValues?.[
                                    field.name
                                  ]
                                )
                              }
                            >
                              <Select
                                name={`invoiceFieldsValues.${field.name}`}
                                value={
                                  formik.values.invoiceFieldsValues[field.name]
                                }
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                sx={{
                                  minWidth: 245,
                                  marginRight: "30px",
                                }}
                              >
                                {durationOptions.map(({ id, label, value }) => (
                                  <MenuItem key={id} value={value}>
                                    {label}
                                  </MenuItem>
                                ))}
                              </Select>
                              {formik.touched.invoiceFieldsValues?.[
                                field.name
                              ] &&
                                formik.errors.invoiceFieldsValues?.[
                                  field.name
                                ] && (
                                  <FormHelperText>
                                    {
                                      formik.errors.invoiceFieldsValues[
                                        field.name
                                      ]
                                    }
                                  </FormHelperText>
                                )}
                            </FormControl>
                          )}
                        </Box>
                      ))}
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Paper>

            <Paper sx={{ mt: 5, p: 2, borderRadius: "12px" }}>
              {renderPawnShop()}
            </Paper>
            <Paper sx={{ mt: 5, p: 2, borderRadius: "12px" }}>
              {renderUsedCar()}
            </Paper>
            <Paper sx={{ mt: 5, p: 2, borderRadius: "12px" }}>
              {renderLand()}
            </Paper>

            <Grid
              item
              //xs={12}
              sx={{ mt: 3, justifyContent: "center", alignItems: "center" }}
              container
              spacing={4}
            >
              <Grid item>
                <GradientButtonOutline
                  type="submit"
                  onClick={() => window.history.back()}
                >
                  กลับ
                </GradientButtonOutline>
              </Grid>

              <Grid item>
                <GradientButton
                  type="submit"
                  //onClick={formik.handleSubmit}
                  style={{ marginRight: "20px" }}
                >
                  บันทึก
                </GradientButton>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
      </form>
    </>
  );
};

export default BillDebtForm;
